import { push } from 'connected-react-router';
import React from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { stringToNumber, roundToFourDecimals } from '../../helpers/functions';
import StagedPremiumSettingsWizardHOC from './stagedPremiumSettingsWizardHOC';
import { getSingleStagedPremium, patchStagedPremium, } from '../../reducers/stagedPremiumsWizard';

const StagedPremiumSettingsEditHOC = () => {
    const { id } = useParams();
    const stagedPremiumSettingsWizard = useSelector( (state) => state.stagedPremiumsWizard );
    const premiumSettings = useSelector((state) => state.premiumSettings);
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getSingleStagedPremium(id));
    }, []);
    const handleSubmit = () => {
        const stagesSettingsBody = Object.values( stagedPremiumSettingsWizard.stagesSubSettings ).map((s) => {
            const premiumAmount = stringToNumber(s.premiumAmount);
            return {
                ...s,
                // Real, full-precision computed amount — this is what's stored. Round to 4dp
                // only to avoid raw floating-point noise; the UI rounds to 2dp for display
                // separately, at render time.
                underwriterRate: roundToFourDecimals(
                    stringToNumber(stagedPremiumSettingsWizard.underwriterRatePercentage) * 0.01 * premiumAmount
                ),
                underwriterRatePercentage: stringToNumber( stagedPremiumSettingsWizard.underwriterRatePercentage ),
                stagedPremiumSubSettingCommissionDtos: Object.values( stagedPremiumSettingsWizard.agentCommissionsList ).map((c) => ({
                    ...c,
                    lawsysId: c.id,
                    lawsysName: c.name,
                    commission: roundToFourDecimals(
                        stringToNumber(c.commissionPercentage) * 0.01 * premiumAmount
                    ),
                    commissionPercentage: stringToNumber(c.commissionPercentage),
                })),
            };
        });
        const payload = {
            id: id,
            body: {
                id: id,
                validFrom: new Date( stagedPremiumSettingsWizard.validFrom )?.toDateString(),
                validUntil: stagedPremiumSettingsWizard.validUntil ? new Date( stagedPremiumSettingsWizard.validUntil )?.toDateString() : null, 
                notes: stagedPremiumSettingsWizard.notes,
                comments: stagedPremiumSettingsWizard.comments,
                solicitorGroupId:
                premiumSettings.selectedSolicitorGroup === ''
                    ? null
                    : parseInt(premiumSettings.selectedSolicitorGroup),
                caseTypeId: parseInt(premiumSettings.selectedCaseType),
                subCaseTypeId:
                premiumSettings.selectedSubCaseType === '' ||
                premiumSettings.selectedSubCaseType === '0'
                    ? null
                    : parseInt(premiumSettings.selectedSubCaseType),
                workSourceId:
                premiumSettings.selectedWorksource === ''
                    ? null
                    : parseInt(premiumSettings.selectedWorksource),
                DeductibleOptionId: stagedPremiumSettingsWizard.selectedDeductible,
                CoverageOptionId: stagedPremiumSettingsWizard.selectedCoverageType,
                EndorsementOptionId: stagedPremiumSettingsWizard.selectedEndorsement,
                StagedPremiumSubSettings: stagesSettingsBody,
                averageExpectedPremium: stagedPremiumSettingsWizard.averageExpectedPremium,
            },
        };
        dispatch(patchStagedPremium(payload));
    };
    return (
        <StagedPremiumSettingsWizardHOC
            isApplicationPremium={false}
            handleSubmit={handleSubmit}
            isEdit={true}
            onCancel={() => dispatch(push('../../premium-settings'))}
            agentsList={stagedPremiumSettingsWizard.agentCommissionsList}
        />
    );
};

export default StagedPremiumSettingsEditHOC;
